import { useAuthStore } from '../stores/oauthStore'

const VITE_API_BASE_URL = import.meta.env.VITE_API_BASE_URL
const VITE_API_KEY = import.meta.env.VITE_API_KEY
const TOKEN_URL = `${VITE_API_BASE_URL}/oauth/v2/token`
const REFRESH_INTERVAL = 25 * 60 * 1000 // 25 minutes in milliseconds

export async function fetchOAuthToken(): Promise<string> {
  const authStore = useAuthStore()

  // Check if a token already exists
  if (
    authStore.token &&
    authStore.tokenExpirationTime &&
    authStore.tokenExpirationTime > Date.now()
  ) {
    return authStore.token
  }

  const data = {
    grant_type: 'https://com.sqills.s3.oauth.public',
    code: import.meta.env.VITE_GRANT_TYPE_INTERNET,
  }

  const response = await fetch(TOKEN_URL, {
    method: 'POST',
    headers: {
      'Authorization': `Basic ${VITE_API_KEY}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  if (!response.ok) {
    throw new Error('Failed to fetch token')
  }

  const responseData = await response.json()
  const token = responseData.access_token

  if (token === null) {
    throw new Error('Failed to retrieve access token')
  }

  const tokenExpirationTime = Date.now() + REFRESH_INTERVAL

  // Store the token and its expiration time
  authStore.setToken(token, tokenExpirationTime)

  return token
}

export function initializeOAuthService() {
  return fetchOAuthToken().catch((error) => {
    console.error('Failed to fetch initial token:', error)
  })
}
